import type { TI_DateData } from '@stratumn/studio-shared';

//? selectedVariable is set in the component on spawn using the selectedVariableRef from the block datInfo
export const initialTIDateData: Omit<TI_DateData, 'selectedVariable'> = {
  title: 'Default Date Title'
};
